<div class="copilot-header" data-element="copilot-tab-bar">
  <dx-button-group
    [items]="this.tabItems"
    keyExpr="id"
    selectionMode="single"
    stylingMode="contained"
    [selectedItemKeys]="[this.activeTab]"
    (onItemClick)="this.onItemClick($event)"
  ></dx-button-group>

  <!-- Reset button AFTER the tabs (OPG/HedgeMatrix CoPilot header pattern): one click resets the whole
       CoPilot window to its default state. Goes yellow (copilot-stale) when the grid has drifted from
       what the CoPilot captured at run time — the click clears it. Enabled during a run (the reset
       drops the in-flight run silently, donor parity). -->
  <dx-button icon="refresh" hint="Reset ORION" data-element="btn-copilot-reset"
             [class.copilot-stale]="this.stale"
             (onClick)="this.onResetClick()"></dx-button>
</div>
